module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-a3ba8173e40f63d2f7afcf6835e9b1ac.png";